import { Table } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    sendedMessageColumns,
    reservedMessageColumns,
    pushNotificationColumn,
    reservedKakaoAlimColumns,
    sendedKakaoAlimColumns,
} from './MessageTableColumnData';
import { getKakaoTemplates } from '../api/messageAPI';
import { getKakaoTemplatesAction } from '../reducers/message';
import { useMemo } from 'react';

const MessageTable = ({
    tab,
    sendType,
    tableData,
    handleIndex,
    index,
    totalIndex,
    scrollPosition,
    setScrollPosition,
    height,
    rowSelection,
    resetKey,
}) => {
    const dispatch = useDispatch();
    const tableRef = useRef(null);
    const isRestoringScrollRef = useRef(false); // 스크롤 복원 중 이벤트 무시용
    const getPushNotificationHistoryDone = useSelector(
        (state) => state.messageReducer.getPushNotificationHistoryDone,
    );
    const {
        getKakaoAlimTalkHistoryDone,
        getKakaoAlimTalkTemplatesDone,
        getMonoMessageHistoryDone,
        kakaoAlimTalkTemplates,
    } = useSelector((state) => state.messageReducer);
    // const [height, setHeight] = useState(parent.current.offsetHeight - 42);

    const messageRowKey = (record) => {
        // 기존 index -> 삭제를 위해 고유한 job_id로 변경
        return record.job_id;
    };

    const pushRowKey = (record, index) => {
        return index;
    };

    const kakaoRowKey = (record, index) => {
        return index;
    };

    const handleScroll = (currentScroll) => {
        setScrollPosition(currentScroll);
    };

    useEffect(() => {
        if (!tableRef.current) return;
        const body = tableRef.current.querySelector('.ant-table-body');
        if (body) {
            body.scrollTop = 0;
        }
    }, [resetKey]);

    useEffect(() => {
        if (tab === 'kakao_alim_talk' && !getKakaoAlimTalkTemplatesDone) {
            dispatch(getKakaoTemplatesAction());
        }
    }, [tab, getKakaoAlimTalkTemplatesDone]);

    /** table에 이벤트 리스너를 추가
     * @todo 교차 관찰자를 통해, 무한 스크롤을 구현하는 것이 성능 개선에 도움이 될 수 있음
     */
    useEffect(() => {
        if (
            tableRef.current &&
            ((tab === 'push_notification' && getPushNotificationHistoryDone) ||
                (tab === 'kakao_alim_talk' && getKakaoAlimTalkHistoryDone) ||
                (tab === 'message' && getMonoMessageHistoryDone))
        ) {
            let table = tableRef.current.querySelector('.ant-table-body');
            const maxScroll = table.scrollHeight - table.clientHeight; // 전체 높이 - 보여지는 높이 = 최대 스크롤 높이

            const scrollEvent = (event) => {
                if (isRestoringScrollRef.current) return;

                const currentScroll = table.scrollTop;
                const currentMaxScroll =
                    table.scrollHeight - table.clientHeight;

                if (
                    currentScroll >= currentMaxScroll - 1 &&
                    handleIndex &&
                    totalIndex !== undefined &&
                    index < totalIndex
                ) {
                    handleScroll(currentScroll);
                    handleIndex();
                }
            };
            table.addEventListener('scroll', scrollEvent);
            // Unmount 안할 시, 이벤트 리스너가 중첩되면서 메모리 누수가 발생합니다
            return () => {
                table.removeEventListener('scroll', scrollEvent);
            };
        }
        // 해상도 변경 시, 현재 변경된 table 높이를 반영하기 위해 의존성 배열에 height 추가
        // height는 window 이벤트로 해상도가 변경되면 다시 계산되어 set된다.
    }, [
        tableData,
        height,
        tab,
        handleIndex, // 최신 값 참조 위해 의존성 추가
        index,
        totalIndex,
        scrollPosition,
        setScrollPosition,
    ]);

    const columns =
        sendType === 'send_history'
            ? sendedMessageColumns
            : reservedMessageColumns;
    const kakaoColumns =
        sendType === 'reserved'
            ? reservedKakaoAlimColumns(kakaoAlimTalkTemplates)
            : sendedKakaoAlimColumns(kakaoAlimTalkTemplates);

    return (
        <React.Fragment>
            {tableData && tab === 'message' && (
                <Table
                    ref={tableRef}
                    // scroll={{ y: parent.current.offsetHeight - 42 }}
                    scroll={{ y: height }}
                    dataSource={tableData}
                    columns={columns}
                    pagination={false}
                    rowKey={messageRowKey}
                    rowSelection={rowSelection}
                    rowHeight={42}
                    key="message"
                />
            )}
            {tableData && tab === 'push_notification' && (
                <Table
                    ref={tableRef}
                    // scroll={{ y: parent.current.offsetHeight - 42 }}
                    scroll={{ y: height }}
                    dataSource={tableData}
                    columns={pushNotificationColumn}
                    pagination={false}
                    rowKey={pushRowKey}
                    rowHeight={42}
                    key="push_notification"
                />
            )}
            {tableData && tab === 'kakao_alim_talk' && (
                <>
                    <Table
                        ref={tableRef}
                        scroll={{ y: height }}
                        dataSource={tableData}
                        columns={kakaoColumns}
                        pagination={false}
                        rowKey={kakaoRowKey}
                        rowHeight={42}
                        key="kakao_alim_talk"
                    />
                </>
            )}
        </React.Fragment>
    );
};

export default MessageTable;
